// extracted by mini-css-extract-plugin
export default {"hideTooltip":"R8-z","fadeIn":"S8-z","delay":"T8-z","recommendedSizeTooltip":"U8-z"};